import { RM_PAYORDER, RM_CONFIRM } from "../apis/payment";

export default {
  data() {
    return {
      query_timer: 0,
      query_pay_num: 0
    };
  },
  methods: {
    /**
     * 多货币充值方式
     */
    async onRmpayPayment(callback) {
      try {
        const params = { batteryType: 1, channel: "h5" };
        const query = {
          paymentId: this.pId,
          amount: this.price || "",
          userOpenId: this.user.p_openID,
          qrCode: this.qrcode || this.$route.query.cabinetID || ""
        };
        this.$loading(true);
        const Payment = this.selectPayment || { paymentMethodType: "" };
        const payUrl = `${RM_PAYORDER}/${query.qrCode}?amount=${query.amount}&payType=WEB_PAYMENT`;
        const head = {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        };
        const { data = {} } = await this.$Request("POST", payUrl, params, head);
        if (data.outTradeNo) {
          if (data.url && Payment.pPaymentType.includes("RmPay")) {
            setTimeout(() => {
              window.location.href = data.url;
            }, 1000);
            return;
          }
        }
        throw new Error(data.message);
      } catch (error) {
        this.$loading(false);
        this.$toast(error);
        throw new Error(error);
      }
    },
    // 多货币确认支付方式
    async RmpayConfirm(outTradeNo, tradeNo, callback) {
      const query = { outTradeNo: outTradeNo || "", tradeNo: tradeNo || "" };
      const { data = {} } = await this.$Request("POST", RM_CONFIRM, query);
      callback && callback(data);
      return data;
    }
  }
};
